
import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfirmacionDialogComponent } from 'src/app/shared/components/confirmacion-dialog/confirmacion-dialog.component';
import { debounceTime, distinctUntilChanged, filter, finalize, startWith, switchMap, tap } from 'rxjs';
import { defaultValueOrRangeValidator, isMobile, isMobileXL, toFormData } from 'src/app/shared/utils/helpers';

import { forkJoin } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { HttpResponse } from '@angular/common/http';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Moneda } from 'src/app/shared/models/moneda';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { TipoCambio } from 'src/app/shared/models/tipoCambio';
import { Usuario } from 'src/app/shared/models/usuario';
import { UsuariosService } from 'src/app/shared/services/usuarios.service';

@Component({
  selector: 'app-tipos-cambio-dialog',
  templateUrl: './tipos-cambio-dialog.component.html'
})
export class TiposCambioDialogComponent implements OnInit {
  codigoTipoCambioEdit: number = -1;
  idMonedaDestinoEdit: string = "";
  idMonedaOrigenEdit: string = "";
  idPaisEdit: string = "";
  form: FormGroup;
  idTipo: number;
  usuarioSeleccionado: Usuario;
  filteredOptions: any;
  formControlAutocomplete = new FormControl();
  hint: string = ""
  isLoading = false;
  minLengthTerm = 2;
  t: TipoCambio;
  mensaje: number = 0;
  monedas: Moneda[] = [];
  fechaHoy: Date;
  minDate: Date;

  public Etiquetas: {

    IdMonedaOrigen: string,
    IdMonedaDestino: string,
    FechaCambio: string,
    Valor: string,
    Habilitacion: string
  }

  public Validaciones: {
    IdMonedaOrigen: string,
    IdMonedaDestino: string,
    FechaCambio: string,
    Valor: string
  }
  constructor(private configService: ConfigService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<TiposCambioDialogComponent>,
    private fb: FormBuilder,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    private usuariosService: UsuariosService,
    private tablasService: TablasService,
    @Inject(MAT_DIALOG_DATA) private data: any) {
    this.form = this.fb.group({
      idMonedaOrigen: ['', [Validators.required]],
      idMonedaDestino: ['', [Validators.required]],
      fechaCambio: ['', [Validators.required]],
      valor: [0, [Validators.required, defaultValueOrRangeValidator(
        0,
        Validators.min(0)
      )]],
      habilitacion: [true],
      codigo: [0],
      autor: [''],
      idPais: ['']
    })



    if (data.idTipo != null) {
      this.idTipo = data.idTipo;
    }
    if (data.tipoCambio != null) {

      this.codigoTipoCambioEdit = data.tipoCambio.codigo;
      this.idMonedaOrigenEdit = data.tipoCambio.idMonedaOrigenEdit;
      this.idMonedaDestinoEdit = data.tipoCambio.idMonedaDestinoEdit;
      this.t = data.tipoCambio;

    }
  }

  ngOnInit() {
    this.Etiquetas = {
      IdMonedaOrigen: this.configService.etiquetas.TiposCambio.IdMonedaOrigen,
      IdMonedaDestino: this.configService.etiquetas.TiposCambio.IdMonedaDestino,
      FechaCambio: this.configService.etiquetas.TiposCambio.FechaCambio,
      Valor: this.configService.etiquetas.TiposCambio.Valor,
      Habilitacion: this.configService.etiquetas.Habilitacion

    }
    this.Validaciones = {
      IdMonedaOrigen: this.configService.validaciones.TiposCambio.Dialog.IdMonedaOrigen,
      IdMonedaDestino: this.configService.validaciones.TiposCambio.Dialog.IdMonedaDestino,
      FechaCambio: this.configService.validaciones.TiposCambio.Dialog.FechaCambio,
      Valor: this.configService.validaciones.TiposCambio.Dialog.Valor,

    }
    this.fechaHoy = new Date();

    this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.mensaje));
    if (this.idTipo == 1) {
      this.idPaisEdit = this.loggedService.logged.idPais;
      this.minDate = new Date();
    }
    forkJoin([
      this.tablasService.cMonedas(this.loggedService.logged.idPais,),
      this.tablasService.cTipoCambioDB(this.codigoTipoCambioEdit)

    ]).subscribe((data: [Moneda[], TipoCambio]) => {

      if (data[0].length) {

        this.monedas = data[0];
      }


      if (this.codigoTipoCambioEdit != -1) {

        if (data[1] != null) {

          //this.form.controls['idPais'].setValue(data[1].idPais);
          this.form.controls['idMonedaOrigen'].setValue(data[1].idMonedaOrigen);
          this.form.controls['idMonedaDestino'].setValue(data[1].idMonedaDestino);
          this.form.controls['valor'].setValue(data[1].valor);
          this.form.controls['fechaCambio'].setValue(data[1].fechaCambio);
          this.form.controls['habilitacion'].setValue(data[1].habilitacion);
          this.form.controls['codigo'].setValue(data[1].codigo);
          this.minDate = data[1].fechaCambio;
          this.form.markAsUntouched();
          this.form.markAsPristine();

        }
      } else {
        this.form.controls['fechaCambio'].setValue(this.fechaHoy);
      }
    });

  }
  guardarTipoCambio() {

    switch (this.idTipo) {
      case 1:
        this.form.controls['autor'].setValue(this.loggedService.logged.userName);
        this.form.controls['idPais'].setValue(this.loggedService.logged.idPais);
        this.tablasService.aTipoCambio(this.form.value).subscribe((data: boolean) => {
          this.mensaje = this.idTipo;
          this.dialogRef.close();
        })
        break;

      case 2:
        this.tablasService
          .mTipoCambio(this.form.value)
          .subscribe((data: boolean) => {
            this.mensaje = this.idTipo;
            this.dialogRef.close();
          });
        break;
    }

  }
  compareMonedas(monedaLista: any, monedaTipoCambio: any): boolean {
    if (typeof monedaLista != 'undefined' && typeof monedaTipoCambio != 'undefined') {

      return monedaLista === monedaTipoCambio;
    }
  }
  selectMonedaOrigen(monedaOrigen: any) {
    if (monedaOrigen == '-1') {
      this.form.controls['idMonedaOrigen'].reset();
    }
  }
  selectMonedaDestino(monedaDestino: any) {
    if (monedaDestino == '-1') {
      this.form.controls['idMonedaDestino'].reset();
    }
  }
  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }

  clearInput(formControlName: string) {
    this.form.controls[formControlName].reset();

  }

  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }
}
